export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يلغي"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يحفظ"])}
}